export default __webpack_public_path__ + "static/media/industrial.a1e389ca.webp";